import { Link } from "react-router-dom";

const sections = [
  {
    title: "Eligibility",
    text: "The metal credit card upgrade is available to eligible PNB credit cardholders, subject to account verification and approval. Submitting a request does not guarantee acceptance.",
  },
  {
    title: "Upgrade and fees",
    text: "Card availability, upgrade fees and any applicable delivery charges will be presented before you confirm your request. Existing credit limits, balances and payment obligations remain subject to your PNB credit card agreement.",
  },
  {
    title: "Cardholder and delivery",
    text: "Where included in the confirmed offer, a complimentary cardholder will be provided with the upgrade. Delivery arrangements depend on availability and your location. Identity verification may be required upon receipt.",
  },
  {
    title: "Information you provide",
    text: "You must provide accurate and current information. Personal information is handled in accordance with the Privacy Policy. Never disclose your PIN, online banking password or one-time password through an upgrade request.",
  },
  {
    title: "Confirmation and cancellation",
    text: "Review all charges and conditions before accepting an upgrade. Any cancellation restrictions or non-refundable charges must be disclosed before confirmation.",
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#F5F6F8] font-good text-[#263B51]">
      <header className="bg-[#1e3a8a]">
        <div className="mx-auto flex h-[4.5rem] max-w-md items-center justify-between px-6">
          <Link to="/" aria-label="Home" className="flex items-center gap-2">
            <img src="/logowhite.png" alt="PNB" className="h-8 w-auto" />
            <span className="text-sm font-bold tracking-widest text-white uppercase">PNB</span>
          </Link>

          <Link
            to="/"
            aria-label="Back to home"
            className="flex h-10 w-10 items-center justify-center rounded-lg text-white/90 transition-colors hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              className="h-5 w-5"
              aria-hidden="true"
            >
              <path
                d="M19 12H5M11 6l-6 6 6 6"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-md px-6 pb-10 pt-10">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="h-[0.1875rem] w-4 rounded-full bg-[#1e3a8a]" />
          <span className="text-xs font-semibold uppercase tracking-widest text-[#1e3a8a]">
            Important information
          </span>
        </div>

        <h1 className="text-3xl font-semibold leading-tight tracking-tight text-[#12345A]">
          Terms & Conditions
        </h1>

        <p className="mt-5 text-sm leading-relaxed text-[#748091]">
          These terms apply to requests for a PNB metal credit card upgrade.
          Please review them before submitting or confirming your request.
        </p>

        <div className="mt-8">
          {sections.map((section) => (
            <section
              key={section.title}
              className="border-t border-[#12345A]/10 py-5"
            >
              <h2 className="text-base font-semibold text-[#12345A]">
                {section.title}
              </h2>

              <p className="mt-2 text-sm leading-relaxed text-[#748091]">
                {section.text}
              </p>
            </section>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-[#12345A]/10 pt-6 text-sm">
          <Link
            to="/"
            className="text-[#12345A] underline-offset-4 hover:underline"
          >
            Back to home
          </Link>

          <Link
            to="/privacy"
            className="text-[#12345A] underline-offset-4 hover:underline"
          >
            Privacy Policy
          </Link>
        </div>
      </main>
    </div>
  );
}